var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from '@tanstack/react-query';
import { changePaymentDueDateCacheKey } from '../shared/change-payment-due-date-cache-key';
import queryFnFactory from './change-payment-due-date-get-query';
export function useChangePaymentDueDateGetQuery(_a) {
    var config = _a.config, keyProps = _a.keyProps, _b = _a.queryOptions, queryOptions = _b === void 0 ? {} : _b;
    return useQuery(__assign({ queryKey: changePaymentDueDateCacheKey(keyProps), queryFn: queryFnFactory(config, keyProps), retry: false, refetchOnMount: 'always' }, queryOptions));
}
